<h4 id="impediment-list">Sachstände</h4>
<div class="container" [class.error]="hasError()">
	@for (group of groups(); track group.id) {
		<details>
			<summary>
				<h5>{{ group.description }}</h5>
			</summary>
			<div style="display: flex; flex-direction: column">
				@for (impediment of group.impediments; track impediment.id) {
					<mat-checkbox
						[disabled]="isDisabled()"
						[checked]="isSelected(impediment.id)"
						(change)="toggleImpediment(impediment.id)"
						>{{ impediment.description }}</mat-checkbox
					>
				}
			</div>
		</details>
	}
</div>
